export default __webpack_public_path__ + "static/media/hindi_gen_m.133c1ec2.wav";